/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type PointsFigureUnit = (typeof PointsFigureUnit)[keyof typeof PointsFigureUnit];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointsFigureUnit = {
  '%': '%',
  pp: 'pp',
  attempts: 'attempts',
  count: 'count',
} as const;
